import { useState } from "react";
import { useLeaveHistoryStore } from "../../store/useLeaveHistoryStore";

export default function DownloadEmployeeLeaveDetails({
  selectedCompanyId,
  setOpenDownloadLeavesPopup,
}) {
  const accessToken = localStorage.getItem("accessToken");
  const permissions = JSON.parse(localStorage.getItem("userPermissions")) || [];

  const currentYear = new Date().getFullYear();
  const previousYear = currentYear - 1;
  const [selectedYear, setSelectedYear] = useState(currentYear);

  const hasDownloadManagedLeaveHistoryPermission = permissions.some(
    (p) => p.name === "view_managed_leave_history",
  );

  const hasDownloadAllLeaveHistoryPermission = permissions.some(
    (p) => p.name === "view_all_leave_history",
  );

  const { fetchLeaveHistory, loading } = useLeaveHistoryStore();

  const handleDownload = () => {
      fetchLeaveHistory({
      accessToken,
      companyId: selectedCompanyId,
      selectedYear,
      hasManagedPermission: hasDownloadManagedLeaveHistoryPermission,
      hasAllPermission: hasDownloadAllLeaveHistoryPermission,
    });
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="relative bg-white rounded-lg  shadow-xl py-6 w-full max-w-md mx-4">
        <div className="flex items-center justify-between pb-2 mb-4 border-b-2 border-gray-300">
          <h4 className="text-xl font-semibold px-6 text-[#909090]">Yearwise Leave Download</h4>
          <span
            onClick={() => setOpenDownloadLeavesPopup(false)}
            className="text-[#909090] px-2 border mr-6 hover:border-2 border-[#909090] hover:border-[#6b6b6b] cursor-pointer"
          >
            x
          </span>
        </div>
        <div className="flex flex-col justify-center items-center gap-2 w-full px-6">
          <p>Select Year</p>
          <select
            value={selectedYear}
            onChange={(e) => setSelectedYear(Number(e.target.value))}
            className="text-xl border border-gray-300 h-14 px-4 rounded-none outline-none focus:border-primary-hrms cursor-pointer"
          >
            <option value={currentYear}>{currentYear}</option>
            <option value={previousYear}>{previousYear}</option>
          </select>
          <button
            onClick={handleDownload}
            className={`text-white bg-primary-hrms text-base w-full py-3 mt-6 ${loading ? "cursor-not-allowed bg-[#909090]" : "cursor-pointer"}`}
          >
            {loading ? "Downloading" : "Download"}
          </button>
        </div>
      </div>
    </div>
  );
}
